export const LOCALES = {
    ENGLISH: 'en',
    RUSSIAN: 'ru',
    UKRAINIAN: 'ua',
}
